// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"429":"b56a86c6","543":"534bf682","787":"d1d4a2c2"}[chunkId] + ".chunk.js";
};